// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabRatingCardBody-modulecomment__Jwyb9";
var _2 = "RequestProfileTabRatingCardBody-modulecommentSection__DSSo1";
var _3 = "RequestProfileTabRatingCardBody-modulefields__Osp7Q";
var _4 = "RequestProfileTabRatingCardBody-modulegalleryStrip__UuuHE";
var _5 = "RequestProfileTabRatingCardBody-moduleratingLabel__nkNuK";
var _6 = "RequestProfileTabRatingCardBody-moduleratingRow__cRCBm";
var _7 = "RequestProfileTabRatingCardBody-moduleratings__kR901";
export { _1 as "comment", _2 as "commentSection", _3 as "fields", _4 as "galleryStrip", _5 as "ratingLabel", _6 as "ratingRow", _7 as "ratings" }
